import { JSX, useEffect, useMemo, useState } from "react";
import { IDataDisplayer } from "components/IDataDisplayer/DataDisplayer";
import { WarehouseGridAdapter } from "components/IDataDisplayer/WarehouseGridAdapter/WarehouseGridAdapter";
import { DataDisplayerService } from "components/IDataDisplayer/DataDiplayerService";
import { DataDisplay } from "components/IDataDisplayer/DataDisplayType";
import { PlanData } from "models/PlanInfos";
import { useAppDispatch } from "hooks/StoreHooks";
import { setIsGridRendered } from "store/Slices/warehousePlanSlice";

interface Props {
  plan: PlanData | null;
  displayType: DataDisplay;
}

export default function PlanDisplayer({
  plan,
  displayType,
}: Props): JSX.Element {
  const dataDisplayMethod = getDataDisplayMethod(displayType);
  if (!dataDisplayMethod) {
    throw new Error("Méthode d'affichage invalide");
  }
  const dispatch = useAppDispatch();
  const displayer = useMemo(
    () => new DataDisplayerService(dataDisplayMethod),
    [dataDisplayMethod]
  );

  const [isDisplayerReady, setIsDisplayerReady] = useState(false);

  const isPlanLoaded: boolean = useMemo(() => (plan ? true : false), [plan]);

  useEffect(() => {
    if (!isPlanLoaded) {
      setIsDisplayerReady(false);
      return;
    }
    displayer.initialisePlan();
    setIsDisplayerReady(true);
    dispatch(setIsGridRendered(true));
  }, [plan, displayer, isPlanLoaded]);
  if (!isDisplayerReady) return <p>Initialisation en cours…</p>;

  return <>{displayer.renderDisplayer()}</>;
}

function getDataDisplayMethod(
  displayType: DataDisplay
): IDataDisplayer | undefined {
  switch (displayType) {
    case DataDisplay.GRID:
      return WarehouseGridAdapter;
    default:
      return undefined;
  }
}
